import ThematicExpandableRow from './ThematicStatisticTable';
import MessageExpandableRow from './MessageExpandableRow';

const AnalyticsExpandableWrapper = ({ data }) => {
  return (
    <div>
      <MessageExpandableRow data={data} />
      <hr />
      <ThematicExpandableRow data={data} />
    </div>
  );
};

export default AnalyticsExpandableWrapper;
